function Header() {
	this.build();
}

Header.prototype.build = function () {
	const that = this;
	this.header = $('header');
	this.buildScenes();

	const fullscreenMenu = $('.fullscreen-menu');
	const button = $('.menu-toggle');
	button.on('click', function () {
		if (that.header.hasClass('menu-open')) {
			that.header.removeClass('menu-open');
			gsap.to(fullscreenMenu, {
				y: '101%',
				duration: 0.7,
				ease: 'expo.inOut',
			});
		} else {
			that.header.addClass('menu-open');
			gsap.to(fullscreenMenu, {
				y: '0%',
				duration: 0.7,
				ease: 'expo.inOut',
			});
		}
	});
};

Header.prototype.buildScenes = function () {
	ScrollTrigger.create({
		trigger: ".scroll-content",
		start: function () {
			return window.innerHeight / 5;
		},
		toggleClass: {
			targets: this.header, className: "header-compact"
		}
	});
};
